import styled from '@emotion/styled';
import BackButton from 'components/Button/BackButton';
import { breakpoints } from 'app/spacing';

const Container = styled.div`
  background-color: ${({ scrolledTop }) =>
    scrolledTop
      ? 'var(--color-background-default)'
      : 'var(--color-background-white)'} !important;
  display: flex;
  max-width: ${breakpoints.xl}px;
`;

const ChildContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  & > button:last-child {
    margin-right: 0;
  }
`;

const ChildCenterContainer = styled(ChildContainer)`
  flex: 1;
  padding-left: 18px;
  padding-right: 8px;
`;

const ChildRightContainer = styled(ChildContainer)`
  gap: 15px;
`;

export const Header = ({
  onGoBack,
  centerContent,
  rightActionButton,
  backButtonTitle,
  scrolledTop,
  goBackPath,
}) => {
  return (
    <Container scrolledTop={scrolledTop}>
      <ChildContainer>
        <BackButton
          to={goBackPath || window.location.pathname}
          variant="text"
          color="blue"
          onClick={onGoBack}
        >
          {backButtonTitle}
        </BackButton>
      </ChildContainer>
      <ChildCenterContainer>{centerContent}</ChildCenterContainer>
      <ChildRightContainer>{rightActionButton}</ChildRightContainer>
    </Container>
  );
};
